import React from "react";
import { LABEL, CUSTOM_MESSAGES } from "../../../veriables";
import { getObjectValue  } from '../../../utility/utills';
import { safeJsonParse } from "../../../utility/helperFunction";
import cn from 'classnames';

export const Items = ({
  tableData,
  countryCode,
  serverAppTheme,
  currenySymbol,
  serviceChargeAmount,
  currentTipValue,
  tipAmount,
  allMenuItems,
  billingHeight,
  paymentHeight,
  loyaltyOffset,
  isDriveThru,
  renderModifier,
  renderModifierView,
  loyaltyState,
  isLandScape,
  getLoyaltyOfferState,
  ...props
}) => {
  const isCounter = getObjectValue(
    () => [1].includes(deviceInfo.deviceGroup.startMode),
    false
  );
  const excludeItemFromReceiptScreen = (item) => {
    let excludeProduct = false;
    allMenuItems?.forEach((insideItems) => {
      if (
        insideItems.id === item.menuItemId &&
        insideItems?.excludeFromReceipt
      ) {
        excludeProduct = true;
      }
    });
    return excludeProduct;
  };

  const seatNumber = item => {
    let seat = '';

    if (item?.seats?.length > 1) {
      seat = item?.seats[0]?.tableOrder ? 'T' : 'S';
    } else {
      seat = props?.seat?.seats?.find(i => i?.id === item?.seats[0]?.seatId)
        ?.number;
    }

    return seat;
  };

  const portraitBaseHeight =
    loyaltyState === 1
      ? '83.2vh'
      : (loyaltyState === 2
        ? '82.2vh'
        : '96.2vh');
        const auth =    safeJsonParse(window.sessionStorage.getItem('auth'), {});
        const footerlines = auth?.footerLines;
         const footerLineCount = footerlines && Array.isArray(footerlines) ? Math.min(footerlines.length, 5) : 0;
    const footerAdjustment = footerLineCount > 0 ? -(footerLineCount * 3) : 0;

  return (
    <div className={("col-12 px-0 mx-0 w-100 d-flex flex-column", isLandScape ? 'pt-0': 'pt-2')}>
      <div
        className="col-11 px-0 d-flex"
        style={{
          color: serverAppTheme?.itemQtyClr,
          position: "sticky",
          top: 0,
          zIndex: 10,
          paddingBottom: isLandScape && '8px'
        }}
      >
        <div className="col-2 p-0 text-center">
          <span> {LABEL().QTY}</span>
        </div>
        <div className="col-7 p-0 pl-1 text-left">
          <div className="mx-0">{LABEL().ITEMS_LIST}</div>
        </div>
        {!isDriveThru && <div className="col-1 p-0 text-left">
          <span> Seat</span>
        </div>}
        <div className={cn(isDriveThru ? "col-4" : "col-3", "text-right pl-0 pr-2")}>
          <span>{LABEL().AMOUNT}</span>
        </div>
      </div>
 
      {/* Scrollable Items List */}
      <div
        className="col-12 px-0 pt-0 w-100 overflowY"
        style={{
          overflowY: "auto",
          flex: "1",
          maxHeight: isLandScape
            ? getLoyaltyOfferState() === 2
              ? `calc(62vh + ${footerAdjustment}vh)`
              : getLoyaltyOfferState() === 1
              ? `calc(71vh + ${footerAdjustment}vh)`
              : `calc(79vh + ${footerAdjustment}vh)`
            : `calc(${portraitBaseHeight} - ${billingHeight + paymentHeight}px - 40px - ${
                !isLandScape && loyaltyState !== 0 ? `${loyaltyOffset}px` : "0px"
              } + ${footerAdjustment}vh)`,
          color: "#FFF",
          minHeight: isLandScape
            ? getLoyaltyOfferState() === 2
              ? `calc(62vh + ${footerAdjustment}vh)`
              : getLoyaltyOfferState() === 1
              ? `calc(71.5vh + ${footerAdjustment}vh)`
              : `calc(80.5vh + ${footerAdjustment}vh)`
            : "",
        }}
      >
        {tableData?.items && tableData?.items.length > 0 ? (
          <>
            {tableData.items.map((item) => {
              const excludeFromReceipt = excludeItemFromReceiptScreen(item);
              if (excludeFromReceipt) return null;

              return (
                <div
                  key={item.menuItemId}
                  className="col-12 px-0 row mx-0 mb-1 py-2 w-100 align-content-center fw-400"
                  style={{
                    backgroundColor: props.detailSection && serverAppTheme?.checkDetail_tabs,
                    borderRadius: "4px",
                  }}
                >
                  {/* Quantity */}
                  <div className="p-0 col-2 px-1 text-center" style={{ color: serverAppTheme?.primary_text }}>
                    <span>
                      {item?.split > 1 ? `${item?.quantity}/${item?.split}` : item?.quantity}
                    </span>
                  </div>

                  {/* Item Name */}
                  <div className="col-6 p-0 text-left pl-0" style={{ color: serverAppTheme?.primary_text }}>
                    <span>
                      {item.menuItemName}
                    </span>
                  </div>

                  {/* Seat Number */}
                  {!isDriveThru && <div className="px-0 pr-0 pl-3 align-items-center col-1 d-flex justify-content-center">
                    <div
                      className="fw-500 color-black roundedSm d-flex justify-content-center align-items-center"
                      style={{
                        width: "2.1rem",
                        height: "1.25rem",
                        background: serverAppTheme?.seat_bg,
                        color: serverAppTheme?.seat_box_text,
                      }}
                    >
                      {seatNumber(
                        item?.seats
                          ? item
                          : props?.seat?.Items?.find(i => i.id === item.id)
                      )}
                    </div>
                  </div>}

                  {/* Price */}
                  <div className={cn(isDriveThru ? "col-4" : "col-3" , "text-right pl-0 pr-3")} style={{ color: serverAppTheme?.primary_text }}>
                    {currenySymbol}
                    {item.price.toFixed(2)}
                  </div>
                  {(isLandScape && !props.viewDetails) ||
                    (isCounter || isDriveThru) ? (
                    <div className="col-12 p-0">
                      {item.modifiers &&
                        renderModifierView(item.modifiers)}
                    </div>
                  ) : (
                    <div
                      className={cn(
                        'col-12 p-0',
                        item.modifiers && 'mt-2'
                      )}
                    >
                      {item.modifiers &&
                        renderModifierView(item.modifiers)}
                    </div>
                  )}
                </div>
              );
            })}

          </>
        ) : (
          <div className="d-flex col-12 px-3 overflowY fs-600 justify-content-center align-items-center" style={{ color: "#A0A0A0" }}>
            {CUSTOM_MESSAGES().NO_ITEM_FOUND}
          </div>
        )}

      </div>

    </div>
  );
};
